import React from 'react';
import {
    Box,
    IconButton,
    Typography,
    Divider
} from '@mui/material';
import {
    ChevronLeft,
    ChevronRight
} from '@mui/icons-material';
import { NavigationSection } from './NavigationSection';
import PrepPhaseSidebar from './PrepPhaseSidebar';
import MatchingPhaseSidebar from './MatchingPhaseSidebar';
import RunningPhaseSidebar from './RunningPhaseSidebar';
import FollowupPhaseSidebar from './FollowupPhaseSidebar';

interface SidebarProps {
    activeSection: NavigationSection;
    handleSectionChange: (section: NavigationSection) => void;
    isSectionAllowed: (section: NavigationSection) => boolean;
    sidebarCollapsed: boolean;
    toggleSidebar: () => void;
    campaignName?: string;
}

const Sidebar: React.FC<SidebarProps> = ({
    activeSection,
    handleSectionChange,
    isSectionAllowed,
    sidebarCollapsed,
    toggleSidebar,
    campaignName = 'Campaign'
}) => {
    return (
        <Box
            component="nav"
            sx={{
                width: sidebarCollapsed ? 70 : 250,
                flexShrink: 0,
                borderRight: '1px solid',
                borderColor: 'divider',
                height: '100%',
                transition: 'width 0.2s ease',
            }}
        >
            {/* Sidebar Header with toggle button */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                borderBottom: '1px solid',
                borderColor: 'divider'
            }}>
                {!sidebarCollapsed && (
                    <Typography variant="h6" sx={{ flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {campaignName}
                    </Typography>
                )}
                <IconButton onClick={toggleSidebar}>
                    {sidebarCollapsed ? <ChevronRight /> : <ChevronLeft />}
                </IconButton>
            </Box>

            {/* Navigation menu items */}
            <Box sx={{ mt: 2, overflowY: 'auto', height: 'calc(100% - 64px)' }}>
                {/* Prep Phase */}
                <PrepPhaseSidebar
                    activeSection={activeSection}
                    handleSectionChange={handleSectionChange}
                    isSectionAllowed={isSectionAllowed}
                    sidebarCollapsed={sidebarCollapsed}
                />

                <Divider sx={{ my: 2 }} />

                {/* Matching Phase */}
                <MatchingPhaseSidebar
                    activeSection={activeSection}
                    handleSectionChange={handleSectionChange}
                    isSectionAllowed={isSectionAllowed}
                    sidebarCollapsed={sidebarCollapsed}
                />

                <Divider sx={{ my: 2 }} />

                {/* Running Phase */}
                <RunningPhaseSidebar
                    activeSection={activeSection}
                    handleSectionChange={handleSectionChange}
                    isSectionAllowed={isSectionAllowed}
                    sidebarCollapsed={sidebarCollapsed}
                />

                <Divider sx={{ my: 2 }} />

                {/* Follow-up Phase */}
                <FollowupPhaseSidebar
                    activeSection={activeSection}
                    handleSectionChange={handleSectionChange}
                    isSectionAllowed={isSectionAllowed}
                    sidebarCollapsed={sidebarCollapsed}
                />
            </Box>
        </Box>
    );
};

export default Sidebar;